import React, { useEffect, useState } from 'react';
import { getWeatherByCity, getWeatherIconUrl, WeatherData } from '../../services/weatherService';

interface WeatherWidgetProps {
  userCity?: string;
  companyCity?: string;
}

const WeatherWidget: React.FC<WeatherWidgetProps> = ({ userCity, companyCity }) => {
  const [weather, setWeather] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        // Use user city first, then company city as fallback
        const cityToUse = userCity || companyCity;

        if (!cityToUse) {
          setLoading(false);
          return;
        }

        try {
          // Fetch weather from backend (backend handles caching)
          const data = await getWeatherByCity(cityToUse);
          setWeather(data);
          setLoading(false);
        } catch (err: any) {
          console.debug('Weather fetch error - API key may still be activating:', err.message);
          setLoading(false);
        }
      } catch (err) {
        console.error('Weather widget error:', err);
        setLoading(false);
      }
    };

    fetchWeather();

    // Refresh weather every 3 hours (server handles caching, so this is just for UI freshness)
    const interval = setInterval(fetchWeather, 3 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, [userCity, companyCity]);

  if (loading || !weather) {
    return null;
  }

  const temp = Math.round(weather.main.temp);
  const iconUrl = getWeatherIconUrl(weather.weather[0].icon);

  return (
    <div
      className="flex items-center space-x-1 text-gray-700 dark:text-gray-300"
      title={`${weather.weather[0].description} in ${weather.name}`}
    >
      <img
        src={iconUrl}
        alt={weather.weather[0].description}
        className="h-8 w-8"
      />
      <span className="text-sm font-medium hidden sm:inline">
        {temp}°F
      </span>
    </div>
  );
};

export default WeatherWidget;
